import http from '@services/http';
export default {
  getItemsMenu(companyId) {
    return http.get('Layouts/GetFormsDataByCompanyId', {
      companyId: companyId
    });
  },

  createOrUpdateLayout(layout) {
    return http.post('Layouts/CreateOrUpdateLayout', layout);
  },

  getLayouts(companyId) {
    return http.get('Layouts/GetLayoutsByCompanyId', {
      companyId: companyId
    });
  }

};